export default "__VITE_ASSET__356ab3e7__"